import axios from "axios";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPlans } from "../../../actions/planactions";
import Loading from "../../../utilities/Loading";

export default function ProfitMargin() {
  const [loading, setLoading] = useState(false);
  const { plans } = useSelector((state) => state.plans);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPlans());
  }, [dispatch]);

  const onChangeText = async (target, id, key) => {
    const { value } = target;
    const updatedPlan = { profit_margin: value };
    await axios.put(`/api/plans/${id}`, updatedPlan);
  };

  const done = async () => {
    setLoading(true);
    await dispatch(getPlans());
    setLoading(false);
    alert("Plan successfully updated");
  };

  return !loading ? (
    <div className="ibox-content">
      {Array.isArray(plans) &&
        plans.map((item, key) => (
          <div className="row mt-1" key={key}>
            <div className="col-12">
              <div className="form-group">
                <label>
                  {item.plan_name} <strong className="text-danger">*</strong>
                </label>
                <div className="input-group m-b">
                  <div className="input-group-prepend">
                    <span className="input-group-addon">$</span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    name={`${item.code_name}`}
                    onChange={({ target }) => onChangeText(target, item._id, key)}
                    defaultValue={item.profit_margin}
                  />
                  <div className="input-group-append">
                    <span className="input-group-addon">.00</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      <div className="row">
        <div className="col-12 d-flex justify-content-end">
          <button type="button" className="btn btn-default mr-2">
            Cancel
          </button>
          <button type="button" className="btn btn-primary" onClick={done}>
            Update
          </button>
        </div>
      </div>
    </div>
  ) : (
    <Loading />
  );
}